import React from 'react'

// Pledgeling Foundation's bank details for wire transfers. Hardcoded just
// like in v6 — these are stable strings tied to the Pledgeling org, not
// per-partner data. (Backend's deferredProps.address is the receiving
// mailing address used for both wire and check.)
const WireBankInfo = ({ i18n, currency }) =>
  <>
    {/* add margin-top to separate from above content */}
    <div className="mt-3">
      <dt className="font-semibold">
        {i18n.t('deferred.receiving_bank')}
      </dt>
      <dd>
        <div>Silicon Valley Bank</div>
        <div>3003 Tasman Drive</div>
        <div>Santa Clara, CA 95054 USA</div>
      </dd>
    </div>

    {/* add margin-top to separate from above content */}
    <div className="flex flex-wrap gap-x-2 mt-3">
      <dt className="font-semibold text-nowrap">
        {i18n.t('deferred.routing_number')}
      </dt>
      <dd>121140399</dd>
    </div>

    <div className="flex flex-wrap gap-x-2">
      <dt className="font-semibold text-nowrap">
        {i18n.t('deferred.swift_code')}
      </dt>
      <dd className="text-nowrap">
        SVBKUS6SXXX {i18n.t('deferred.or')} SVBKUS6S
      </dd>
    </div>

    {/* add margin-top to separate from above content */}
    <div className="flex flex-wrap gap-x-2 mt-3">
      <dt className="font-semibold text-nowrap">
        {i18n.t('deferred.account_number')}
      </dt>
      <dd>3303866848</dd>
    </div>

    <div className="flex flex-wrap gap-x-2">
      <dt className="font-semibold text-nowrap">
        {i18n.t('deferred.account_type')}
      </dt>
      <dd>{i18n.t('deferred.checking')}</dd>
    </div>

    <div className="flex flex-wrap gap-x-2">
      <dt className="font-semibold text-nowrap">
        {i18n.t('currency')}
      </dt>
      <dd>{currency.iso_code}</dd>
    </div>
  </>

const RecipientInfo = ({ i18n, paymentMethod, address, ein }) =>
  <>
    <div>
      <dt className="font-semibold">
        {paymentMethod === 'wire'
          ? i18n.t('deferred.wire_money_to')
          : i18n.t('deferred.make_check_payable_to')}
      </dt>
      <dd>
        <div>Pledgeling Foundation</div>
        <div dangerouslySetInnerHTML={{ __html: address }} />
      </dd>
    </div>

    {/* add margin-top to separate from above content */}
    <div className="flex flex-wrap gap-x-2 mt-3">
      <dt className="font-semibold text-nowrap">
        {i18n.t('email')}
      </dt>
      <dd>accounting@pledgeling.org</dd>
    </div>

    <div className="flex flex-wrap gap-x-2">
      <dt className="font-semibold text-nowrap">
        EIN
      </dt>
      <dd>{ein}</dd>
    </div>
  </>

const DeferredInstructions = ({ i18n, currency, paymentMethod, deferredProps }) =>
  <div className="rounded-lg bg-gray-100 p-4">
    {paymentMethod === 'pledge' ? (
      <p>{i18n.t('deferred.pledge_instructions')}</p>
    ) : (
      <div className="space-y-3">
        <p>{i18n.t('deferred.intro')}</p>
        <dl>
          <RecipientInfo
            i18n={i18n}
            paymentMethod={paymentMethod}
            address={deferredProps.address}
            ein={deferredProps.ein}
          />
          {paymentMethod === 'wire' && (
            <WireBankInfo i18n={i18n} currency={currency} />
          )}
        </dl>
      </div>
    )}
  </div>

export default DeferredInstructions
